import { Component } from '@theme/component';

/**
 * "See gifts" button + modal for the product page offer banner.
 * Lists the theme's free gift products. Gifts are claimed in the cart drawer
 * (cart-free-gift).
 */
class OfferGiftPopup extends Component {
  #banner = null;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
    this.#banner = this.closest('.anniversary-offer');
    this.#banner?.addEventListener('click', this.#handleBannerClick);
    this.#dialog?.addEventListener('cancel', this.#handleCancel);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
    this.#banner?.removeEventListener('click', this.#handleBannerClick);
    this.#banner = null;
    this.#dialog?.removeEventListener('cancel', this.#handleCancel);
  }

  get #dialog() {
    const dialog = this.querySelector('[data-offer-gift-dialog]');
    return dialog instanceof HTMLDialogElement ? dialog : null;
  }

  #handleBannerClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const dialog = this.#dialog;
    if (!target || !dialog || dialog.open || target.closest('a, button, input, select, textarea, [data-offer-gift-dialog]')) return;
    this.querySelector('[data-offer-gift-open]')?.click();
  };

  #handleClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const dialog = this.#dialog;
    if (!target || !dialog) return;

    if (target.closest('[data-offer-gift-open]')) {
      if (!dialog.open) dialog.showModal();
      return;
    }

    // A click on a native dialog's backdrop has the dialog itself as its target.
    if (target === dialog || target.closest('[data-offer-gift-close]')) this.#close();
  };

  /** @param {Event} event */
  #handleCancel = (event) => {
    event.preventDefault();
    this.#close();
  };

  #close() {
    const dialog = this.#dialog;
    if (!dialog?.open || dialog.hasAttribute('data-closing')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return dialog.close();

    dialog.setAttribute('data-closing', '');
    window.setTimeout(() => {
      dialog.close();
      dialog.removeAttribute('data-closing');
    }, 220);
  }
}

if (!customElements.get('offer-gift-popup')) customElements.define('offer-gift-popup', OfferGiftPopup);
